import { EventSlider } from './EventSlider'
export class GetPost {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      const { createApp } = Vue
      createApp({
        data() {
          return {
            posts: '',
            slider: null,
          }
        },
        methods: {
          getPosts() {
            axios
              .get('https://www.biwakokisen.co.jp/wp-json/wp/v2/custom_season_event')
              .then((response) => {
                this.posts = response.data
                this.$nextTick().then(() => {
                  this.initSlider()
                })
              })
              .catch((error) => {
                this.errors = error
              })
          },
          initSlider() {
            new EventSlider()
          },
        },
        mounted() {
          this.getPosts()
        },
      }).mount('#js-vue-post')
    })
  }
}
